module.exports = __webpack_public_path__ + "fbd41f2047fdacc7c9fea5fbabb2b814.pdf";